"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[361],{

/***/ 1114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Alert; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 9 modules
var polished_esm = __webpack_require__(6637);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/themes/default/components/Alert/styles.ts
/* eslint-disable no-nested-ternary */ 
function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-self: flex-start;\n  text-align: ",
        ";\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  color: ",
        ";\n\n  border-radius: ",
        ";\n  font-size: ",
        ";\n  line-height: 18px;\n  padding: ",
        " ",
        ";\n  width: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fa1b2655-0"
})(_templateObject(), (param)=>{
    let { textAlign  } = param;
    return textAlign;
}, (p)=>p.theme.colors[p.color], (p)=>(0,polished_esm/* transparentize */.DZ)(0.65, p.theme.colors[p.color]), (p)=>(0,polished_esm/* readableColor */.XV)((0,polished_esm/* lighten */.$n)(0.2, p.theme.colors[p.color]), p.theme.colors.textDark, p.theme.colors.textLight), (p)=>p.theme.borderRadius, (p)=>p.theme.font.small, (p)=>p.theme.spacing.medium, (p)=>p.theme.spacing.large, (p)=>p.width ? p.width === "full" ? "100%" : "".concat(p.width * 100, "%") : "");

;// CONCATENATED MODULE: ./src/themes/default/components/Alert/index.tsx


const Alert = (param)=>{
    let { children , color ="primary" , width , textAlign ="center"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        className: "Alert",
        color: color,
        width: width,
        textAlign: textAlign,
        children: children
    });
};
/* harmony default export */ var components_Alert = (Alert);


/***/ })

}]);